import React from "react";
import { Button } from "@/components/ui/button";
import neuralBg from "@/assets/auraxp-neural-bg.jpg";

const HeroSection = () => {
  return (
    <section className="relative py-16 md:py-24 lg:py-32 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img 
          src={neuralBg} 
          alt="" 
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background/80 via-background/60 to-background/80" />
      </div>
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-5xl mx-auto text-center space-y-6">
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-foreground leading-tight">
            AuraXP, Your Organization's <span className="text-[#8932c8]">Intelligent Cyber Brain</span>
          </h1>
          <p className="text-xl md:text-2xl font-semibold text-foreground">
            <span className="text-[#8932c8]">AuraXP™</span> - Autonomous Unified Response Agent with Xtended Protection
          </p>
          <p className="text-lg md:text-xl text-muted-foreground font-medium">
            Your Organization's Intelligence Never Leaves.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center pt-6">
            <Button
              size="lg"
              className="bg-[#8932c8] hover:bg-[#8932c8]/90 text-white font-semibold px-8 py-6 text-lg"
              onClick={() => window.open('https://outlook.office.com/bookwithme/user/3c14c6b9047b45dfb64e4bc9045f29dd%40spharaka.com/meetingtype/p0-SnGKD_EqEPlSvi_wdNg2?anonymous&ismsaljsauthenabled', '_blank')}
            >
              Book a Demo
            </Button>
            <Button
              size="lg"
              variant="outline"
              className="border-2 border-[#8932c8] text-[#8932c8] hover:bg-[#8932c8]/10 font-semibold px-8 py-6 text-lg"
              onClick={() => window.open('/contact', '_blank')}
            >
              Partner with Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
